export { default as Icon } from "./Icon";
export type { IconProps, IconName, IconSize } from "./Icon";
export * as icons from "./svg";
